module.exports = __webpack_public_path__ + "img/W-14.49ec2b2a.jpg";